import React from 'react';
import { PropTypes } from 'prop-types';
import Input from '../widgets/Input';
import { Button } from '@progress/kendo-react-buttons';

const ForgotPasswordForm = ({
    onSubmit,
    onChange,
    errors,
    email,
    client
}) => (
         <div className="login-container">

                <div className="panel panel-default">

                    <div className="panel-heading">
						<img src="/assets/Images/Logo_2.png" />
                        <span>Reset your password</span>
                        <div className="login-heading-divider"></div>
                    </div>
                    <div className="panel-body">
                    <form>

                        <div className="form-login">
                            
                            <div className="login-field-wrap">
                                <span className="mdi mdi-domain login-field-icon"></span>
                                <Input props={{label:'Client'}} value={client} type='text' name='client' error={errors.client} onChange={onChange} />
                            </div>
                            <div className="login-field-wrap">
                                <span className="mdi mdi-email-outline login-field-icon"></span>
                                <Input props={{label:'Email'}} value={email} type='text' name='email' error={errors.email} onChange={onChange}  />
                            </div>
                          
                            <p className="top-40">
                                <Button style={{width: '100%', height: 50, fontSize: '16px', borderRadius: '8px'}} themeColor={'primary'} onClick={onSubmit}>
                                    <span className="mdi mdi-email-send-outline" style={{marginRight: 8}}></span>Send Email
                                </Button>
                            </p> 
                            <p className="top-40">
                                <a className="login-forgot-link" href='/'><span className="mdi mdi-arrow-left" style={{marginRight: 4}}></span>Login</a>                        
                            </p>

                            <div className="login-footer">&copy; Checkpoint 2026</div>

                        </div>
                    </form>
                </div>

            </div>

        </div>
		
    );

ForgotPasswordForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired
};

export default ForgotPasswordForm;